import consola from 'consola'

function clock(start) {
	if (!start) return process.hrtime()
	const end = process.hrtime(start)
	return Math.round(end[0] * 1000 + end[1] / 1000000)
}

export const state = () => ({
	scToken: null,
	platform: null,
	showRegistrationButton: false,
	inApp: true,
	initialLoading: true,
	isChinese: false,
	isPlayActive: false,
	region: null,
	apiToken: null,
	country: null,
	playerTag: null,
	thNotHighEnough: false,
	showCheckInButton: false,
	inRegistrationClosedPeriod: false,
	inCheckinPeriod: false,
	isCheckedIn: false,
	inPlayPeriod: false,
	afterDayOnePeriod: false,
	beforeDayTwoPeriod: false,
	beforePlayPeriod: false,
	notInvited: false,
	clanRosterId: null,
	clanDidNotCreateRoster: false,
	globalCreateWarLoading: false,
	hasNavActions: true,
})

export const mutations = {
	setScToken(state, scToken) {
		state.scToken = scToken
	},
	setPlatform(state, platform) {
		state.platform = platform
	},
	setShowRegistrationButton(state, showRegistrationButton) {
		state.showRegistrationButton = showRegistrationButton
	},
	setInApp(state, inApp) {
		state.inApp = inApp
	},
	setInitialLoading(state, initialLoading) {
		state.initialLoading = initialLoading
	},
	setIsChinese(state, isChinese) {
		state.isChinese = isChinese
	},
	setRegion(state, region) {
		state.region = region
	},
	setApiToken(state, apiToken) {
		state.apiToken = apiToken
	},
	setCountry(state, country) {
		state.country = country
	},
	setPlayerTag(state, playerTag) {
		state.playerTag = playerTag
	},
	setThNotHighEnough(state, thNotHighEnough) {
		state.thNotHighEnough = thNotHighEnough
	},
	setShowCheckinButton(state, showCheckInButton) {
		state.showCheckInButton = showCheckInButton
	},
	setInRegistrationClosedPeriod(state, inRegistrationClosedPeriod) {
		state.inRegistrationClosedPeriod = inRegistrationClosedPeriod
	},
	setInCheckinPeriod(state, inCheckinPeriod) {
		state.inCheckinPeriod = inCheckinPeriod
	},
	setInPlayPeriod(state, inPlayPeriod) {
		state.inPlayPeriod = inPlayPeriod
	},
	setAfterDayOnePeriod(state, afterDayOnePeriod) {
		state.afterDayOnePeriod = afterDayOnePeriod
	},
	setBeforeDayTwoPeriod(state, beforeDayTwoPeriod) {
		state.beforeDayTwoPeriod = beforeDayTwoPeriod
	},
	setBeforePlayPeriod(state, beforePlayPeriod) {
		state.beforePlayPeriod = beforePlayPeriod
	},
	setIsCheckedIn(state, isCheckedIn) {
		state.isCheckedIn = isCheckedIn
	},
	setNotInvited(state, notInvited) {
		state.notInvited = notInvited
	},
	setClanRosterId(state, clanRosterId) {
		state.clanRosterId = clanRosterId
	},
	setClanDidNotCreateRoster(state, clanDidNotCreateRoster) {
		state.clanDidNotCreateRoster = clanDidNotCreateRoster
	},
	setGlobalCreateWarLoading(state, globalCreateWarLoading) {
		state.globalCreateWarLoading = globalCreateWarLoading
	},
	setHasNavActions(state, hasNavActions) {
		state.hasNavActions = hasNavActions
	},
}

export const actions = {
	async nuxtServerInit({ commit, dispatch }, { $config }) {
		const startTime = clock()
		try {
			if ($config.inApp !== 'true' && $config.inApp !== true) {
				commit('setInApp', false)
				commit('setApiToken', $config.apiSecret)
			}
			if ($config.isChina === 'true' || $config.isChina === true) {
				commit('setIsChinese', true)
			}
			await dispatch('event/getEvents')
			const endTime = clock(startTime)
			// eslint-disable-next-line no-console
			console.log(endTime + ' ms')
		} catch (err) {
			consola.error('nuxtServerInit failed', err)
		}
	},
}
